import { Component, Input } from '@angular/core';

@Component({
  selector: 'lk-cover-card',
  templateUrl: './cover-card.component.html',
  styleUrls: ['./cover-card.component.scss']
})
export class CoverCardComponent {
  @Input() cover;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/components/cover-card/cover-card.component.ts